var _circle, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuizQuestionRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.25,
    stroke: "#DC4955",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 10.25,
    x2: 15,
    y2: 10.25,
    stroke: "#DC4955",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizQuestionRemoveIcon);
export default __webpack_public_path__ + "static/media/quiz-question-remove-icon.da6d6f31a1f5e362795894fda34fb332.svg";
export { ForwardRef as ReactComponent };